module.exports = __webpack_public_path__ + "img/minus.d08da8c9.png";